import { OrderStatus } from 'enums';

import { useOrderContext } from './use-order-context.hook';

// Gateway links come from the provider; only follow plain http(s) URLs so a malicious/misconfigured provider
// cannot inject a javascript:/data: (or other scheme) href XSS into the SCI. http is permitted (local mocks,
// non-TLS providers); only script schemes are blocked.
const toSafeLink = (link?: string | null) =>
  link && /^https?:\/\//i.test(link) ? link : null;

export const useGatewayRedirect = () => {
  const {
    paymentTypeFlags: { isEcom },
    requisitesPaymentLink,
    providerPaymentUrl,
    status,
  } = useOrderContext();

  const isCustomerConfirm = status === OrderStatus.CustomerConfirm;
  const safePaymentLink = toSafeLink(requisitesPaymentLink);
  const safeProviderPaymentUrl = toSafeLink(providerPaymentUrl);

  // Redirect-type ecom providers (e.g. manypay) map their active state to CustomerConfirm and carry the
  // gateway link in payment_url; send the customer there instead of the generic P2P requisites view.
  // WaitingConfirmation is the fastpay wait-for-code step and is handled by the OTP form, never a
  // redirect — even though that order also carries a payment_url (the 3DS page).
  const ecomRedirectLink = isEcom && isCustomerConfirm ? safePaymentLink : null;

  // P2P provider with useProviderPaymentUrl enabled (shop- or provider-level): the backend sends
  // providerPaymentUrl only when the redirect should happen, so presence is the whole signal.
  const providerRedirectLink =
    !ecomRedirectLink && isCustomerConfirm ? safeProviderPaymentUrl : null;

  return {
    ecomRedirectLink,
    providerRedirectLink,
    redirectLink: ecomRedirectLink ?? providerRedirectLink,
  };
};
